import React, { useEffect, useState } from 'react';
import FullCalendar, { formatDate } from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import rrulePlugin from '@fullcalendar/rrule';
import EventTasks from './event-tasks';
import { CreateEventsFromBlocks } from './process';
import EventMenu from './event-menu';

const Calendar = ({data, setCalendarDate, setRefresh, editBlockGroup}) => {  
  const [events, setEvents] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [popOverData, setPopoverData] = useState();

  const [jsEvent, setJSEvent] = useState();
  const [selectedEvent, setSelectedEvent] = useState();


  const openMenu = (e, event) => {
    onEventMouseLeave();
    setJSEvent(e);
    setSelectedEvent(event);    
  }

  const onOpCompleted = () => {
    setRefresh(new Date());
  }
  
  const selectEvents = (groupId, select) => {
    const ev = [...events];

    ev.forEach((x) => {
      if (x.groupId == groupId) {
        selectEvent(x, select);
      } else {
        selectEvent(x, false);
      }
    })
    
    setEvents(ev);
  }

  const selectEvent = (event, select) => {
    event.extendedProps.selected = select;
    event.classNames = select ? "calendar-event-selected" : undefined;
  }

  const headerToolbar = {
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay'
  }

  const onEventRender = (info) => {
    if (info.event.extendedProps.isBreak) return;
    
    var div = document.createElement('div'); 
    div.className="event-actions";
    div.innerHTML = "<b>...</b>";
    div.onclick = function(e) { openMenu(e, info.event); }
    info.el.appendChild(div);
  }

  const onDatesSet=(dateInfo) => {
    setCalendarDate(dateInfo.view.calendar.getDate());
  }

  const onEventClick = (info) => {
    selectEvents(info.event.groupId, !info.event.extendedProps.selected);
  }

  const onEventMouseEnter=(info) => {
    if (info.event.extendedProps.anyAppointment || info.event.extendedProps.blkTableType == 2 || info.event.extendedProps.isBreak) return; //if any appointment or blackout or break

    setPopoverData(info.event.extendedProps.apptTypes);
    setAnchorEl(info.el);
  }

  const onEventMouseLeave=() => {
    setPopoverData(null);
    setAnchorEl(null);
  }

  const isSingleEvent = (groupId) => {
    const evs = events.filter((x) => x.groupId == groupId);
    let dt = [];
    evs.forEach((x)=>{
      if (!dt.some((y)=>y == x.extendedProps.editSingleEvent.toLocaleDateString())) dt.push(x.extendedProps.editSingleEvent.toLocaleDateString());
    })
    return dt.length == 1;
  }

  useEffect(()=> {
    if (data) {
      const ev = CreateEventsFromBlocks(data);
      setEvents(ev);
    }
  }, [data]);

  return (
    <>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin]}
        headerToolbar={headerToolbar}    
        events={events}
        datesSet={onDatesSet}
        eventMouseEnter={onEventMouseEnter}
        eventMouseLeave={onEventMouseLeave}
        eventDidMount={onEventRender}
        eventClick={onEventClick}
        slotMinTime={"06:00"}
        allDaySlot={false}
        initialView="timeGridWeek"
        editable={false}
        selectable={false}
        selectMirror={true}
        dayMaxEvents={true}
        weekends={true}
      />
      {popOverData && <EventTasks el={anchorEl} setEl={setAnchorEl} data={popOverData} />}
      <EventMenu jsEvent={jsEvent} event={selectedEvent} selectEvents={selectEvents} onOpCompleted={onOpCompleted} editBlockGroup={editBlockGroup} isSingleEvent={isSingleEvent} />
    </>
  );
}

export default Calendar;